angular.module('bizmetryApp').controller('DatasourceEditDialogController', function (
  $scope, $http, $mdDialog, $timeout, CONFIG, datasource, isEdit,
  ReferenceDataService, $mdToast, DatasourceService, dialogService, agents
) {

  // ============================================
  // INIT
  // ============================================

  $scope.availableAgents     = agents;
  $scope.currentUser         = JSON.parse(sessionStorage.getItem('user') || '{}');
  $scope.datasource          = angular.copy(datasource || { datasourceType: 'MYSQL' });
  $scope.isEditMode          = isEdit;
  $scope.testSuccessful      = false;
  $scope.isTestingConnection = false;
  $scope.validated           = false;
  $scope.savingDatasource    = false;

  // Name uniqueness validation
  $scope.nameExists          = false;
  $scope.checkingName        = false;
  $scope._existingNames      = [];

  const defaultPorts = {
    MYSQL: 3306, POSTGRESQL: 5432, SQLSERVER: 1433, ORACLE: 1521, MONGODB: 27017
  };

  if ($scope.datasource.datasourcePort != null) {
    $scope.datasource.datasourcePort = parseInt($scope.datasource.datasourcePort);
  }

  if ($scope.isEditMode) {
    $scope.originalDatasource       = angular.copy($scope.datasource);
    $scope.validated                = true;
    $scope.isTestConnectionDisabled = true;
  } else {
    $scope.validated                = false;
    $scope.isTestConnectionDisabled = false;
  }

  DatasourceService.getDatasources($scope.currentUser.id)
    .then(function (data) {
      var list = Array.isArray(data) ? data : (data.content || data.items || []);
      $scope._existingNames = list.map(function (d) {
        return (d.datasourceName || '').trim().toLowerCase();
      });
    })
    .catch(function () {
      $scope._existingNames = [];
    });

  // ============================================
  // NAME UNIQUENESS
  // ============================================

  var _nameCheckTimer = null;

  $scope.$watch('datasource.datasourceName', function (newVal, oldVal) {
    if (newVal === oldVal) return;
    if (_nameCheckTimer) $timeout.cancel(_nameCheckTimer);

    var trimmed = (newVal || '').trim();
    if (!trimmed) {
      $scope.nameExists   = false;
      $scope.checkingName = false;
      return;
    }

    $scope.checkingName = true;

    _nameCheckTimer = $timeout(function () {
      var lower        = trimmed.toLowerCase();
      var originalName = $scope.isEditMode && $scope.originalDatasource
        ? ($scope.originalDatasource.datasourceName || '').trim().toLowerCase()
        : null;

      $scope.nameExists   = lower !== originalName && $scope._existingNames.indexOf(lower) !== -1;
      $scope.checkingName = false;
    }, 350);
  });

  // ============================================
  // TYPE WATCH
  // ============================================

  $scope.$watch('datasource.datasourceType', function (newType) {
    if (newType && defaultPorts[newType] && !$scope.datasource.datasourcePort) {
      $scope.datasource.datasourcePort = defaultPorts[newType];
      $scope.validated                = false;
      $scope.isTestConnectionDisabled = false;
    }
  });

  // ============================================
  // CONNECTION PARAM WATCHES
  // ============================================

  var _connectionFields = ['datasourceHost', 'datasourcePort', 'datasourceUser', 'datasourcePassword', 'datasourceDbName'];

  _connectionFields.forEach(function (field) {
    $scope.$watch('datasource.' + field, function (newVal, oldVal) {
      if (newVal !== oldVal && $scope.validated) {
        $scope.validated                = false;
        $scope.isTestConnectionDisabled = false;
      }
    });
  });

  // ============================================
  // CHANGE DETECTION
  // ============================================

  $scope.hasChanges = function () {
    if (!$scope.isEditMode || !$scope.originalDatasource) return true;

    return $scope.datasource.datasourceName        !== $scope.originalDatasource.datasourceName        ||
           $scope.datasource.datasourceDescription !== $scope.originalDatasource.datasourceDescription ||
           $scope.datasource.datasourceType        !== $scope.originalDatasource.datasourceType        ||
           $scope.datasource.datasourceHost        !== $scope.originalDatasource.datasourceHost        ||
           $scope.datasource.datasourcePort        !== $scope.originalDatasource.datasourcePort        ||
           $scope.datasource.datasourceUser        !== $scope.originalDatasource.datasourceUser        ||
           $scope.datasource.datasourcePassword    !== $scope.originalDatasource.datasourcePassword    ||
           $scope.datasource.datasourceDbName      !== $scope.originalDatasource.datasourceDbName      ||
           $scope.datasource.agentId               !== $scope.originalDatasource.agentId;
  };

  // ============================================
  // CANCEL
  // ============================================

  $scope.cancel = function () {
    $mdDialog.cancel();
  };

  // ============================================
  // TEST CONNECTION
  // ============================================

  $scope.canTestConnection = function () {
    return !$scope.nameExists                      &&
           !$scope.checkingName                    &&
           !!$scope.datasource.datasourceType      &&
           !!$scope.datasource.datasourceHost      &&
           !!$scope.datasource.datasourcePort      &&
           !!$scope.datasource.datasourceUser      &&
           !!$scope.datasource.datasourcePassword  &&
           !!$scope.datasource.datasourceDbName    &&
           !$scope.isTestingConnection             &&
           !$scope.isTestConnectionDisabled;
  };

  $scope.testConnection = function () {
    if (!$scope.canTestConnection()) return;
    $scope.isTestingConnection = true;

    const payload = {
      datasourceType:     $scope.datasource.datasourceType,
      datasourceHost:     $scope.datasource.datasourceHost,
      datasourcePort:     $scope.datasource.datasourcePort,
      datasourceUser:     $scope.datasource.datasourceUser,
      datasourcePassword: $scope.datasource.datasourcePassword,
      datasourceDbName:   $scope.datasource.datasourceDbName
    };

    DatasourceService.testConnection($scope.datasource.agentId, payload)
      .then(function (data) {
        $scope.testSuccessful           = true;
        $scope.validated                = true;
        $scope.isTestConnectionDisabled = true;
        openConnectionResultDialog('Connection Successful', data, false);
      })
      .catch(function (error) {
        $scope.testSuccessful = false;
        $scope.validated      = false;
        const message = (error.data && (error.data.message || error.data.error)) || 'Unknown error';
        openConnectionResultDialog('Connection Failed', message, true);
      })
      .finally(function () {
        $scope.isTestingConnection = false;
      });
  };

  // ============================================
  // SAVE
  // ============================================

  $scope.canSave = function () {
    return $scope.hasChanges() && $scope.validated && !$scope.nameExists && !$scope.checkingName;
  };

  $scope.saveDatasource = function () {
    if ($scope.datasource.agentId) {
      const selected = $scope.availableAgents.find(a => a.agentId === $scope.datasource.agentId);
      if (selected) {
        $scope.datasource.agentName       = selected.agentName;
        $scope.datasource.environmentId   = selected.environmentId;
        $scope.datasource.environmentName = selected.environmentName;
      }
    }

    $scope.savingDatasource = true;

    DatasourceService.saveDatasource($scope.datasource, $scope.currentUser.id, $scope.isEditMode)
      .then(function (responseData) {
        // ✅ Patch applied — close dialog and signal refresh to parent
        $mdDialog.hide(true);
      })
      .catch(function (error) {
        var status    = error.status;
        var errorData = error.data || {};

        // ── 409: reconciliation conflicts ──────────────────────────────────
        if (status === 409 && errorData.status === 'CONFLICT' && Array.isArray(errorData.conflicts)) {
          openConflictsDialog(errorData.conflicts);
          return;
        }

        // ── Any other error ────────────────────────────────────────────────
        var msg   = errorData.message || errorData.error || 'Unexpected error saving datasource.';
        var title = $scope.isEditMode ? 'Update Failed' : 'Creation Failed';
        dialogService.showErrorDialog(title, dialogService.formatErrorMessage(msg));
      })
      .finally(function () {
        $scope.savingDatasource = false;
      });
  };

  // ============================================
  // CONFLICTS DIALOG
  // ============================================

  function openConflictsDialog(conflicts) {
    $mdDialog.show({
      controller:   'DatasourceConflictDialogController',
      templateUrl:  'home/main-menu/datasources/edit-datasource/datasource-conflicts-dialog.html',
      parent:       angular.element(document.body),
      clickOutsideToClose: true,
      escapeToClose:       true,
      multiple:            true,
      locals: { conflicts: conflicts }
    });
  }

  // ============================================
  // CONNECTION RESULT DIALOG
  // ============================================

  function openConnectionResultDialog(title, data, isError) {
    if (isError) {
      dialogService.showErrorDialog('Connection Failed', dialogService.formatErrorMessage(data));
    } else {
      $mdDialog.show({
        controller:   'ConnectionResultDialogController',
        templateUrl:  'home/main-menu/datasources/edit-datasource/connection-result/connection-result-dialog.html',
        parent:       angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose:       true,
        multiple:            true,
        locals: { title: title, data: data, isError: isError }
      });
    }
  }

});